import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { IconWithTooltip } from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";

export default function ReportAssetScrapComponent() {
  const navigate = useNavigate();
  const [assetScrapList, setAssetScrapList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Scrap`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetScrapList(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetScrapList = async (assetScrapId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetScrapList(assetScrapId);
      setAssetScrapList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetScrapList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      const idPrefix = `icon-${cellData?.data?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View asset scrap request"
                                tooltip="View asset scrap request"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/ViewAssetScrapRequest", {
                                    state: {
                                      stateData: cellData.data,
                                      requestId: cellData.data?.id,
                                      isReport: true,
                                    },
                                  })
                                }
                              />
                            </span>
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetScrapNo"
                    caption="Asset Scrap No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="projectName"
                    caption="Project"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.projectName || ""} ${
                        data?.locationName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.projectName ?? ""}</span>
                          {data?.data?.locationName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.locationName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transferType"
                    caption="Scrap Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="scrappedDate"
                    caption="Requested Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />

                  <Column
                    dataField="assetScrapStatus"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="approvedDate"
                    caption="Approved By"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.approvedDate || ""} ${
                        data?.approvedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.approvedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.approvedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.approvedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.approvedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="note"
                    caption="Note"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetScrapList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset Request Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
